import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { baseUniDriverFactory } from '../../testkitUtils/unidriver';
import { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './constants';

export interface CounterBadgeDriver extends BaseUniDriver {
  getContent(): Promise<string>;
}

export const counterBadgeDriverFactory = (
  base: UniDriver,
): CounterBadgeDriver => {
  return {
    ...baseUniDriverFactory(base),
    getContent: async () => base.$(`[data-hook=${DATA_HOOKS.VALUE}]`).text(),
  };
};
